import { useEffect, useState } from "react";
import { getExpeditionIdentifier } from "@/lib/expedition.util";
import { ExpeditionFormProps } from "@/components/backOffice/expeditionForm/expeditionForm.types";
import { QuotationExpeditionFormStepOne } from "@/components/backOffice/expeditionForm/quotationExpeditionForm/quotationExpeditionFormStepOne";
import { QuotationExpeditionFormStepTwo } from "@/components/backOffice/expeditionForm/quotationExpeditionForm/quotationExpeditionFormStepTwo";
import { FinalizeApi } from "@/types/finalizeApi.type";

export const QuotationExpeditionForm = ({ expedition, company, apiEnum }: ExpeditionFormProps) => {
  const expeditionIdentifier = getExpeditionIdentifier(expedition);

  const [formStep, setFormStep] = useState(expedition.finalizeIndex);
  const [selectedApiEnum, setSelectedApiEnum] = useState<FinalizeApi>(apiEnum);

  useEffect(() => {
    if (formStep === 1) {
      setSelectedApiEnum(apiEnum);
    }
  }, [apiEnum, formStep]);

  useEffect(() => {
    const defaultTitle = "Pelican Air Services";
    if (expeditionIdentifier) {
      document.title = `${expeditionIdentifier} - ${formStep}/2`;
    }
    return () => {
      document.title = defaultTitle;
    };
  }, [expeditionIdentifier, formStep]);

  if (formStep === 1) {
    return (
      <QuotationExpeditionFormStepOne
        expedition={expedition}
        company={company}
        apiEnum={apiEnum}
        formStep={formStep}
        setFormStep={setFormStep}
        onApiEnumConfirmed={setSelectedApiEnum}
      />
    );
  }

  return (
    <QuotationExpeditionFormStepTwo
      expedition={expedition}
      apiEnum={selectedApiEnum}
      formStep={formStep}
      setFormStep={setFormStep}
      company={company}
    />
  );
};
